"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatePackageRequest = void 0;
var PackageType_1 = require("./PackageType");
var Delivery_1 = require("./Delivery");
var ItemUnit_1 = require("./ItemUnit");
var PackageContent_1 = require("./PackageContent");
var PackageID_1 = require("./PackageID");
var StoreCurrency_1 = require("./StoreCurrency");
var UpdatePackageRequest = (function () {
    function UpdatePackageRequest(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            this.deliveries = [];
            this.goods = [];
            this.storeID = {};
            this.meta = {};
            return;
        }
        this.name = data.name;
        this.type_ = PackageType_1.PackageType[data.type];
        this.deliveries = data.deliveries.map(function (e) { return new Delivery_1.Delivery(e); });
        this.anchorCurrency = StoreCurrency_1.StoreCurrency[data.anchorCurrency];
        this.anchorCost = data.anchorCost;
        this.goods = data.goods.map(function (e) { return new ItemUnit_1.ItemUnit(e); });
        this.public_ = data.public;
        this.disabled = data.disabled;
        this.storeID = Object.keys(data.storeID).reduce(function (previous, current) { previous[current] = data.storeID[current]; return previous; }, {});
        this.meta = Object.keys(data.meta).reduce(function (previous, current) { previous[current] = data.meta[current]; return previous; }, {});
        this.id = new PackageID_1.PackageID(data.id);
    }
    UpdatePackageRequest.prototype.getPackageName = function () { return UpdatePackageRequest.PackageName; };
    UpdatePackageRequest.prototype.getClassName = function () { return UpdatePackageRequest.ClassName; };
    UpdatePackageRequest.prototype.getFullClassName = function () { return UpdatePackageRequest.FullClassName; };
    Object.defineProperty(UpdatePackageRequest.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field name is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field name expects type string, got ' + value);
            }
            this._name = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UpdatePackageRequest.prototype, "type_", {
        get: function () {
            return this._type;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field type_ is not optional');
            }
            this._type = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UpdatePackageRequest.prototype, "deliveries", {
        get: function () {
            return this._deliveries;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field deliveries is not optional');
            }
            this._deliveries = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UpdatePackageRequest.prototype, "anchorCurrency", {
        get: function () {
            return this._anchorCurrency;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field anchorCurrency is not optional');
            }
            this._anchorCurrency = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UpdatePackageRequest.prototype, "anchorCost", {
        get: function () {
            return this._anchorCost;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field anchorCost is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field anchorCost expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field anchorCost is expected to be an integer, got ' + value);
            }
            this._anchorCost = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UpdatePackageRequest.prototype, "goods", {
        get: function () {
            return this._goods;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field goods is not optional');
            }
            this._goods = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UpdatePackageRequest.prototype, "public_", {
        get: function () {
            return this._public;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field public_ is not optional');
            }
            if (typeof value !== 'boolean') {
                throw new Error('Field public_ expects boolean type, got ' + value);
            }
            this._public = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UpdatePackageRequest.prototype, "disabled", {
        get: function () {
            return this._disabled;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field disabled is not optional');
            }
            if (typeof value !== 'boolean') {
                throw new Error('Field disabled expects boolean type, got ' + value);
            }
            this._disabled = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UpdatePackageRequest.prototype, "storeID", {
        get: function () {
            return this._storeID;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field storeID is not optional');
            }
            this._storeID = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UpdatePackageRequest.prototype, "meta", {
        get: function () {
            return this._meta;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field meta is not optional');
            }
            this._meta = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UpdatePackageRequest.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    UpdatePackageRequest.prototype.toPackageContentSerialized = function () {
        var _this = this;
        return {
            name: this.name,
            type: PackageType_1.PackageType[this.type_],
            deliveries: this.deliveries.map(function (e) { return e.serialize(); }),
            anchorCurrency: StoreCurrency_1.StoreCurrency[this.anchorCurrency],
            anchorCost: this.anchorCost,
            goods: this.goods.map(function (e) { return e.serialize(); }),
            public: this.public_,
            disabled: this.disabled,
            storeID: Object.keys(this.storeID).reduce(function (previous, current) { previous[current] = _this.storeID[current]; return previous; }, {}),
            meta: Object.keys(this.meta).reduce(function (previous, current) { previous[current] = _this.meta[current]; return previous; }, {})
        };
    };
    UpdatePackageRequest.prototype.toPackageContent = function () {
        return new PackageContent_1.PackageContentStruct(this.toPackageContentSerialized());
    };
    UpdatePackageRequest.prototype.loadPackageContentSerialized = function (slice) {
        this.name = slice.name;
        this.type_ = PackageType_1.PackageType[slice.type];
        this.deliveries = slice.deliveries.map(function (e) { return new Delivery_1.Delivery(e); });
        this.anchorCurrency = StoreCurrency_1.StoreCurrency[slice.anchorCurrency];
        this.anchorCost = slice.anchorCost;
        this.goods = slice.goods.map(function (e) { return new ItemUnit_1.ItemUnit(e); });
        this.public_ = slice.public;
        this.disabled = slice.disabled;
        this.storeID = Object.keys(slice.storeID).reduce(function (previous, current) { previous[current] = slice.storeID[current]; return previous; }, {});
        this.meta = Object.keys(slice.meta).reduce(function (previous, current) { previous[current] = slice.meta[current]; return previous; }, {});
    };
    UpdatePackageRequest.prototype.loadPackageContent = function (slice) {
        this.loadPackageContentSerialized(slice.serialize());
    };
    UpdatePackageRequest.prototype.serialize = function () {
        var _this = this;
        return {
            name: this.name,
            type: PackageType_1.PackageType[this.type_],
            deliveries: this.deliveries.map(function (e) { return e.serialize(); }),
            anchorCurrency: StoreCurrency_1.StoreCurrency[this.anchorCurrency],
            anchorCost: this.anchorCost,
            goods: this.goods.map(function (e) { return e.serialize(); }),
            public: this.public_,
            disabled: this.disabled,
            storeID: Object.keys(this.storeID).reduce(function (previous, current) { previous[current] = _this.storeID[current]; return previous; }, {}),
            meta: Object.keys(this.meta).reduce(function (previous, current) { previous[current] = _this.meta[current]; return previous; }, {}),
            id: this.id.serialize()
        };
    };
    UpdatePackageRequest.PackageName = 'net.playq.services.bookkeeper';
    UpdatePackageRequest.ClassName = 'UpdatePackageRequest';
    UpdatePackageRequest.FullClassName = 'net.playq.services.bookkeeper.UpdatePackageRequest';
    return UpdatePackageRequest;
}());
exports.UpdatePackageRequest = UpdatePackageRequest;
PackageContent_1.PackageContentStruct.register(UpdatePackageRequest.FullClassName, UpdatePackageRequest);
var irt_1 = require("@playq/irt");
irt_1.Introspector.register(UpdatePackageRequest.FullClassName, {
    full: UpdatePackageRequest.FullClassName,
    short: UpdatePackageRequest.ClassName,
    package: UpdatePackageRequest.PackageName,
    type: irt_1.IntrospectorTypes.Data,
    ctor: function () { return new UpdatePackageRequest(); },
    fields: [
        {
            name: 'name',
            accessName: 'name',
            type: { intro: irt_1.IntrospectorTypes.Str }
        },
        {
            name: 'type',
            accessName: 'type_',
            type: { intro: irt_1.IntrospectorTypes.Enum, full: 'net.playq.services.bookkeeper.PackageType' }
        },
        {
            name: 'deliveries',
            accessName: 'deliveries',
            type: { intro: irt_1.IntrospectorTypes.List, value: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.services.bookkeeper.Delivery' } }
        },
        {
            name: 'anchorCurrency',
            accessName: 'anchorCurrency',
            type: { intro: irt_1.IntrospectorTypes.Enum, full: 'net.playq.services.bookkeeper.StoreCurrency' }
        },
        {
            name: 'anchorCost',
            accessName: 'anchorCost',
            type: { intro: irt_1.IntrospectorTypes.I32 }
        },
        {
            name: 'goods',
            accessName: 'goods',
            type: { intro: irt_1.IntrospectorTypes.List, value: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.services.bookkeeper.ItemUnit' } }
        },
        {
            name: 'public',
            accessName: 'public_',
            type: { intro: irt_1.IntrospectorTypes.Bool }
        },
        {
            name: 'disabled',
            accessName: 'disabled',
            type: { intro: irt_1.IntrospectorTypes.Bool }
        },
        {
            name: 'storeID',
            accessName: 'storeID',
            type: { intro: irt_1.IntrospectorTypes.Map, key: { intro: irt_1.IntrospectorTypes.Enum, full: 'net.playq.services.bookkeeper.Store' }, value: { intro: irt_1.IntrospectorTypes.Str } }
        },
        {
            name: 'meta',
            accessName: 'meta',
            type: { intro: irt_1.IntrospectorTypes.Map, key: { intro: irt_1.IntrospectorTypes.Str }, value: { intro: irt_1.IntrospectorTypes.Str } }
        },
        {
            name: 'id',
            accessName: 'id',
            type: { intro: irt_1.IntrospectorTypes.Id, full: 'net.playq.services.bookkeeper.PackageID' }
        }
    ]
});
//# sourceMappingURL=UpdatePackageRequest.js.map